import { Button, Modal } from 'AWS-UI-Components-React';
import React from 'react';
import { formatTimeFrameToYYYYMM } from '../../../utils/date-utils';
import { TimeFrameButton } from '../../buttons/time_frame_button';

export class CompareMonthWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //TODO: remove hardcoded start/end month after data range is determined
      startMonth:202010,
      endMonth: 202102,
      selectedTimeFrames: [],
    };
  };

  onCancel = () => {
    this.props.onCancel();
  };


  onSubmit = () => {
    const formattedYYYYMMMs = this.state.selectedTimeFrames.map(tf => parseInt(formatTimeFrameToYYYYMM(tf)));
    this.props.onSubmit(formattedYYYYMMMs);
  };

  setTimeFrame = (chosen) => {
    this.setState({selectedTimeFrames: chosen.detail.selectedIds});
  };

  render() {
    return (
      <Modal
        visible={true}
        size="medium"
        header={'Add Months to Compare'}
        expandToFit={true}
        onDismiss={this.onCancel}
        footer={
          <span className="awsui-util-f-r">
            <Button text="Cancel" onClick={this.onCancel} />
            <Button variant="primary" text="Compare" onClick={this.onSubmit} disabled={!this.state.selectedTimeFrames}/>
          </span>
        }
        content={
          <div style={{marginBottom: '5em'}}>
            <TimeFrameButton
              text="Month"
              startMonth={this.state.startMonth}
              endMonth={this.state.endMonth}
              onChange={this.setTimeFrame}
              selected={this.state.selectedTimeFrames}
              multiSelect={true}
              exclude={this.props.exclude}
              data-cy="time-frame-button"
              required={true}
              yearQuarter={false}
            />
          </div>
        }
      />
    );
  };
}


// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/compare_month_window.jsx